import { getPath } from '@/router/common'
const baseUrl = {
  title: '末端成本报表',
  path: 'endcost'
}

export default [
  {
    path: getPath('commonReport', baseUrl),
    name: 'commonReport',
    component: () => import(/* webpackChunkName: "endcost_commonReport" */ '@/views/endcost/commonReport/index.vue'),
    meta: {
      title: '末端成本报表'
    }
  },
]
